export default __webpack_public_path__ + "static/miami_back-7013e415d2d32dd2f2887d287e687990.webp";